module.exports = __webpack_public_path__ + "static/media/icon_paper_plane.0c9a366a.svg";